import {Component, input} from '@angular/core';


@Component({
    selector: 'tgrid-loading-mask',
    standalone: true,
    imports: [],
    template: `
        <div class="loading-mask">
            <div class="spinner-container">
                <div class="spinner">
                    @for (bar of bars; track bar) {
                        <div class="bar" [style.--bar-index]="bar"></div>
                    }
                </div>
                @if (message()) {
                    <p class="loading-text">{{ message() }}</p>
                }
            </div>
        </div>
    `,
    styleUrls: ['./loading-mask.component.scss'],
})
export class LoadingMaskComponent {
    public message = input('Loading');

    // Create an array of 8 bars for the spinner animation
    protected readonly bars = Array(8)
        .fill(0)
        .map((_, i) => i);
}
